<studio-button-legacy
  class="dropdown-radio-button"
  [matMenuTriggerFor]="matMenuRadio"
  (menuOpened)="menuOpened()"
  (menuClosed)="menuClosed()"
  [theme]="buttonTheme"
  [attr.data-selected]="selectedOption | get : displayKey"
  [iconSize]="iconSize"
  [iconLeft]="iconPosition === 'left' ? iconName : null"
  [iconRight]="iconPosition === 'right' ? iconName : null"
  [iconDirection]="iconDirection"
>
  <span data-test="dropdown-label">{{ (selectedOption | get : displayLabel) || placeHolder }}</span>
</studio-button-legacy>

<mat-menu class="studio-dropdown" #matMenuRadio>
  <mat-radio-group>
    <ng-container *ngFor="let option of options">
      <div
        class="studio-dropdown-radio"
        [attr.data-option]="option | get : displayKey"
        [class.studio-dropdown-active]="option | isActive : selectedOption : displayKey"
        (click)="optionSelect(option)"
      >
        <mat-radio-button
          [checked]="option | isActive : selectedOption : displayKey"
          [value]="option | get : displayKey"
        >
          {{ option | get : displayLabel }}
        </mat-radio-button>
      </div>
    </ng-container>
  </mat-radio-group>
</mat-menu>
